module.exports = function($) {
    class menu {

        constructor() {
            this.init();
            this.bind();
        }

        init() {

        }

        bind() {
            $('.openmenu, .closemenu').on('click', function () {
                $('body').toggleClass('open-menu');
            })
            $('header#header .menu-language .current-language').on('click', function () {
                $('header#header .menu-language').toggleClass(
                    'open'
                );
            })
        }
    }

    new menu();

}
